<template>  <button 
    @click="toggleDarkMode"
    class="dark-mode-toggle"
    :aria-label="mounted ? (isDark ? 'Switch to light mode' : 'Switch to dark mode') : 'Toggle dark mode'"
    :title="mounted ? (isDark ? 'Switch to light mode' : 'Switch to dark mode') : 'Toggle dark mode'"  >
    <span class="toggle-emoji">{{ mounted ? (isDark ? '☀️' : '🌙') : '🌙' }}</span>
  </button>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useDarkMode } from '~/composables/useDarkMode'

const { isDark, toggleDarkMode } = useDarkMode()
const mounted = ref(false)

onMounted(() => {
  mounted.value = true
})
</script>

<style scoped>
.dark-mode-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 8px;
  background: var(--color-surface);
  color: var(--color-text-dark);
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid var(--color-border-light);
}

.dark-mode-toggle:hover {
  background: var(--color-primary-bg);
  border-color: var(--color-primary);
  transform: translateY(-1px);
}

.dark-mode-toggle:active {
  transform: translateY(0);
}

.toggle-emoji {
  font-size: 20px;
  transition: transform 0.2s ease;
}

.dark-mode-toggle:hover .toggle-emoji {
  transform: rotate(15deg) scale(1.1);
}

/* Mobile styles */
@media (max-width: 768px) {
  .dark-mode-toggle {
    width: 44px; /* WCAG 2.1 AA minimum touch target */
    height: 44px;
  }
  
  .toggle-emoji {
    font-size: 20px;
  }
}
</style>
